import { useDisplayThreadState } from './useDisplayThreadState'
import { useThreadMessagesState } from './useThreadMessagesState'

/** @param {ReturnType<typeof import('./usePersistedChatState').usePersistedChatState>} state */
export function useChatDerivedState(state) {
  const display = useDisplayThreadState(state)
  const messages = useThreadMessagesState(state, display.displayThreadId)
  return { ...display, ...messages }
}
